module.exports = __webpack_public_path__ + "img/clientelelabel.6354df53.svg";